export default __webpack_public_path__ + "static/media/delete-icon.3fc824d0.svg";